export const CONFIG = {
  API_URL: "https://www.bidzone.ir",
  APP_NAME: "BidZone",
};


